import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useActiveWeb3React } from '../../hooks'
import { useBlockNumber } from '../../state/application/hooks'

const BlockWrapper = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: ${({ theme }) => theme.bg1};
  border: 1px solid ${({ theme }) => theme.bg3};
  border-radius: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.text3};
  z-index: 10;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.text1};
  }
`

const StatusDot = styled.div<{ $syncing?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ theme, $syncing }) => ($syncing ? theme.yellow1 : theme.green1)};
  animation: ${({ $syncing }) => ($syncing ? 'pulse 1s infinite' : 'none')};

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`

const BlockText = styled.span`
  font-variant-numeric: tabular-nums;
`

export default function BlockNumber() {
  const { chainId } = useActiveWeb3React()
  const blockNumber = useBlockNumber()
  const [isSyncing, setIsSyncing] = useState(false)
  const [lastBlock, setLastBlock] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (blockNumber && lastBlock && blockNumber > lastBlock) {
      setIsSyncing(true)
      const timer = setTimeout(() => setIsSyncing(false), 500)
      return () => clearTimeout(timer)
    }
    setLastBlock(blockNumber)
  }, [blockNumber, lastBlock])

  if (!chainId || !blockNumber) {
    return null
  }

  return (
    <BlockWrapper>
      <StatusDot $syncing={isSyncing} />
      <BlockText>{blockNumber.toLocaleString()}</BlockText>
    </BlockWrapper>
  )
}
